module.exports = __webpack_public_path__ + "img/freepractice.ff58b112.png";